import './index.scss'
$(document).ready(function() {  
    const $fixedSocial = $('.fixed-social');  
    const $footer = $('footer');  
  
    function isMobile() {  
      return $(window).width() < 768; // 用于判断是否为手机端  
    }  
  
    function handleScroll() {  
      if (!isMobile()) return; // 如果不是手机端，直接返回  
  
      const scrollTop = $(this).scrollTop();  
      const footerTop = $footer.offset().top; // footer的顶部位置  
      const footerHeight = $footer.outerHeight(); // footer的高度  
      const windowHeight = $(window).height(); // 当前窗口的高度  
  
      // 当内容滚动到 footer 顶部时  
      if (scrollTop + windowHeight >= footerTop) {  
        // 计算.bottom的值，使其正好在footer上面  
        const offsetFromBottom = parseFloat(getComputedStyle(document.documentElement).fontSize) * 0.7; // 0.7rem转换为px  
        const newBottom = footerHeight + offsetFromBottom; // 使固定社交按钮的位置紧贴footer  
  
        $fixedSocial.css('bottom', newBottom);  
        $fixedSocial.addClass('sticky'); // 添加sticky类  
      } else {  
        // 恢复到原来的显示位置  
        $fixedSocial.css('bottom', '0.7rem');  
        $fixedSocial.removeClass('sticky');  
      }  
    }  
  
    // 屏幕尺寸变化时检查  
    $(window).on('resize', function() {  
      if (!isMobile()) {  
        $fixedSocial.css('bottom', '0.7rem').removeClass('sticky'); // 在桌面端重置位置  
      }  
    });  
  
    // 绑定滚动事件  
    $(window).on('scroll', handleScroll);  
  });